/**
 * Extracts the scope type -field or operation-, and the script type 
 * -primary or all- from the params build during the creation of the 
 * export selector menu by the function generateOperationOrFieldOption
 */
export const getScopeAndScriptTypeFromParams = (params: string) => {
  const splitParamas = params.split('|');
  const [scopeType] = splitParamas.at(0).split('~');
  const scriptType = splitParamas.at(2);

  return { scopeType, scriptType };
};
